import React from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'
import ProtectedRoute from 'routes/ProtectedRoute'
import SettingsContainer from 'container/RoxAdminContainer/SettingsContainer'
import ClientContainer from 'container/RoxAdminContainer/ClientProfileContainer'
import PlatformPartnerContainer from 'container/RoxAdminContainer/PlatformPartnerContainer'
import ProfileContainer from 'container/Profile'
import CsvContainer from 'container/RoxAdminContainer/CsvContainer'
import Page404 from 'components/Page404'
import DashboardContainer from 'container/Dashboard'
import Menu from 'components/RoxAdmin/Settings/menu'
import SamgovUsage from 'components/RoxAdmin/SamgovUsage'
import NppesUsage from 'components/RoxAdmin/NppesUsage'
import LeieUsage from 'components/RoxAdmin/LeieUsage'
import OfacUsage from 'components/RoxAdmin/OfacUsage'
import StateMedicaidUsage from 'components/RoxAdmin/StateMedicaidUsage'
import DataSourcesHub from 'components/RoxAdmin/DataSourcesHub'
import InteractionResponses from 'components/RoxAdmin/InteractionResponses'
import ReceivedHooks from 'components/RoxAdmin/ReceivedHooks'
import NotificationEmails from 'components/RoxAdmin/NotificationEmails'
import EmailTemplates from 'components/RoxAdmin/EmailTemplates'

const RoutesRoot = () => {
    return (
        <Switch>
            <ProtectedRoute
                exact
                isAuth={true}
                path='/dashboard'
                component={DashboardContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/settings'
                component={Menu}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/settings/clients'
                component={SettingsContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/client/:clientId"
                component={ClientContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path='/settings/platform-partners'
                component={PlatformPartnerContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/manage-csv"
                component={CsvContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/profile"
                component={ProfileContainer}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/data-sources"
                component={DataSourcesHub}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/samgov-usage"
                component={SamgovUsage}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/nppes-usage"
                component={NppesUsage}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/leie-usage"
                component={LeieUsage}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/ofac-usage"
                component={OfacUsage}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/state-medicaid-usage"
                component={StateMedicaidUsage}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/interaction-responses"
                component={InteractionResponses}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/received-hooks"
                component={ReceivedHooks}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/notification-emails"
                component={NotificationEmails}
            />
            <ProtectedRoute
                exact
                isAuth={true}
                path="/settings/email-templates"
                component={EmailTemplates}
            />
            <Route render={(props) => <Page404 {...props} />} />
        </Switch>
    );
};

export default withRouter(RoutesRoot);
